const isShopifyTracked = (inventoryManagement) => (
  inventoryManagement && String(inventoryManagement).toLowerCase() === "shopify"
);

const applyProductLevelStock = (quantity, inventoryManagement) => {
  if (!isShopifyTracked(inventoryManagement)) {
    return {
      trackedCount: 0,
      oosCount: 0,
      hasSellable: false,
    };
  }
  const qty = quantity || 0;
  return {
    trackedCount: 1,
    oosCount: qty > 0 ? 0 : 1,
    hasSellable: qty > 0,
  };
};

const getVariantStockStats = ({ quantity = 0, inventoryManagement, variants = [] } = {}) => {
  let trackedCount = 0;
  let oosCount = 0;
  let hasSellable = false;

  if (variants && variants.length) {
    variants.forEach((variant) => {
      if (!isShopifyTracked(variant.inventoryManagement)) {
        return;
      }
      trackedCount += 1;
      const variantQty = variant.inventoryQuantity || 0;
      if (variantQty > 0) {
        hasSellable = true;
      } else {
        oosCount += 1;
      }
    });

    // No product-level fallback when the product has variants: its own quantity is
    // not meaningful there, and falling back to it reports a stocked product as out
    // of stock whenever the variants are untracked.
    if (trackedCount && isShopifyTracked(inventoryManagement) && (quantity || 0) > 0) {
      // Product-level qty > 0 also counts as sellable (same as Mongo sellableStockQuery)
      hasSellable = true;
    }
  } else {
    const productLevel = applyProductLevelStock(quantity, inventoryManagement);
    trackedCount = productLevel.trackedCount;
    oosCount = productLevel.oosCount;
    hasSellable = productLevel.hasSellable;
  }

  return {
    trackedCount,
    oosCount,
    hasSellable,
    isFullyOutOfStock: trackedCount > 0 && !hasSellable,
    hasPartialOos: trackedCount > 1 && oosCount > 0 && hasSellable,
  };
};

const getStockBadgeLabel = (product, cms) => {
  const stats = getVariantStockStats(product);
  if (stats.isFullyOutOfStock) {
    return cms("label.outOfStock") || "Out of stock";
  }
  if (stats.hasPartialOos) {
    const { oosCount } = stats;
    const noun = oosCount === 1 ? "variant" : "variants";
    return cms("label.variantsOutOfStock", { count: oosCount }) || `${oosCount} ${noun} out of stock`;
  }
  return null;
};

const productStockHelper = {
  getVariantStockStats,
  getStockBadgeLabel,
  isShopifyTracked,
};

export default productStockHelper;
